import { doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { firestore } from "@redux/firebase";

/**
 * Riaccende un account disattivato quando la persona rientra (STU-462).
 *
 * «Disattiva account» non cancella niente: scrive `AccountDeleted: true` e le mail
 * automatiche di studio (functions: reengagement, promemoriaVerifiche, prova) lo saltano.
 * La mail 13 promette che chi torna con la stessa email ritrova tutto: qui il flag torna
 * false, cosi' l'account riprende a funzionare come prima, promemoria compresi.
 *
 * Si chiama nei tre accessi accanto a `markReturnVisit` (email e password, Google, Apple).
 * Non blocca mai l'accesso: se la scrittura fallisce si riprova al prossimo.
 */
export const riattivaSeDisattivato = async (uid, dati) => {
  if (!uid || !dati || dati.AccountDeleted !== true) return false;
  try {
    await updateDoc(doc(firestore, "students", uid), {
      AccountDeleted: false,
      riattivatoIl: serverTimestamp(),
    });
    return true;
  } catch (error) {
    console.warn("[disattivazione] riattivazione non riuscita, riprovo al prossimo accesso", error);
    return false;
  }
};
